import BlockType116Component from '@headlines/components/block/111-120/BlockType116.vue';
import { AdminBlockType } from '@headlines/types/block/adminBlockType';
import AdminBlockTypeAttributes from '@headlines/config/block/shared/attributes/AdminBlockTypeAttributes';

const AdminBlockType116: AdminBlockType = {
  component: BlockType116Component,
  attributes: AdminBlockTypeAttributes({
    iframe: false,
    className: '',
    embedName: '',
  }),
  articlesCount: 0,
};

export default AdminBlockType116;
